import { inject, Service } from '@angular/core';

import { BaasAppState } from '@lvflanders/bar';
import { BarInitializedHook } from '@lvflanders/bar-ng';
import { StartschermCoreOptions } from '@lvflanders/startscherm-ng-ui';

import { ApiConfiguration } from '../api/api-configuration';
import { TEVREDENHEIDSMETER_CONSTANTS } from '../tevredenheidsmeter.constants';

@Service({ autoProvided: false })
export class TevredenheidsmeterStartupService implements BarInitializedHook {
    readonly #startschermCoreOptions = inject(StartschermCoreOptions);
    readonly #apiConfiguration = inject(ApiConfiguration);
    readonly #appState = inject(BaasAppState);

    run() {
        const rootUrl = this.#defineRootUrl();
        this.#apiConfiguration.rootUrl = rootUrl;
    }

    #defineRootUrl(): string {
        const url =
            location.hostname === 'localhost'
                ? this.#startschermCoreOptions?.isLocal
                    ? 'https://' + location.hostname + ':44397'
                    : this.#appState.location.release.origin + TEVREDENHEIDSMETER_CONSTANTS.STARTSCHERM_URL_SEGMENT
                : location.origin + TEVREDENHEIDSMETER_CONSTANTS.STARTSCHERM_URL_SEGMENT;
        return url;
    }
}
